<template>
  <div>
    <msg v-if="role !== 'C'" :title="$t('cart.payment.success')" :description="description" :buttons="buttons" :icon="icon"></msg>
    <msg v-else :title="$t('cart.payment.success')" :buttons="button" :icon="icon"></msg>
    <div v-transfer-dom>
      <alert v-model="alert" title='提醒' @on-hide="onHide">由於你是非註冊用户，強烈建議你到“查看我的訂單“頁面，以螢幕截圖形式紀錄訂單詳情供日後查詢</alert>
    </div>
  </div>
</template>

<script type="text/javascript">

import { Msg, Divider, XButton, Alert, TransferDomDirective as TransferDom} from 'vux'
import Cookies from 'js-cookie';
import Vue from 'vue'

export default {
  name: 'Success',
  directives: {
    TransferDom
  },
  components: {
    Msg,
    Divider,
    XButton,
    Alert,
  },
  props: {},
  data() {
    return {
      description: this.$t('cart.payment.shareMsg'),
      icon: 'success',
      buttons:
      [{
        type: 'primary',
        text: this.$t('cart.payment.backToShop'),
        onClick: this.backToShop.bind(this)
      }, {
        type: 'default',
        text: this.$t('cart.payment.backToOrder'),
        onClick: this.backToOrder.bind(this)
      }],
      button:[{
        type: 'primary',
        text: this.$t('cart.payment.backToOrder'),
        onClick: this.backToOrder.bind(this)
      }],
      alert: false,
    }
  },
  created() {
    document.title = this.$t('kol.footer.success');
    this.$store.commit("hideFooter", true);
    this.$store.commit('clearShoppingCart');
    this.$store.commit('updateLocalStorageCartList')
    if(this.redirect == 'true'){
      this.alert = true;
    }
  },
  mounted() {},
  watch: {},
  computed: {
    redirect (){
      return Cookies.get('redirect');
    },
    role (){
      return Cookies.get('role');
    }
  },
  methods: {
    backToShop(){
      this.$router.replace('/shop/list?link='+Cookies.get('shopLink'));
    },
    backToOrder(){
      this.$router.replace('/account/order');
    },
    onHide() {
      this.alert = false;
    }
  },
}

</script>
<style type="text/css">

</style>




// WEBPACK FOOTER //
// src/Cart/containers/Success.vue